const laxuraPlatinum = {
    title: "Luxara Platinum Mattress",
    content: {
        "Queen Price": "$2,490",
        "Mattress Type": "Luxury Hybrid Innerspring",
        "Mattress Height": "36cm",
        "Number of Layers": "11",
        "Quilted Pillow Top": "10cm",
        "Top Cover": "100% Bamboo Natural Fabric",
        "Wool Layer": "Yes",
        "Side Handles": "Yes",
        "Compressed in a Box": "No",
        "Queen Spring Count": "740 + Micro Coils = 2020 Total",
        "Spring Layers": "Dual Layer of Springs",
        "Micro-Spring Layer": "Individually Pocketed Micro Springs",
        "Spring Foundation Layer": "Individually Pocketed Springs",
        "Triple tempered Steel Springs": "Yes",
        "GECA Certification": "Yes",
        "Gel-Infused Memory Foam Layer": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "Yes",
        "Australian Made Dunlop Foam Layers": "Yes",
        "Antimicrobial Treatment": "Ultra-Fresh™ Antimicrobial Treatment",
        "Multi-Zone Body Support": "5-Zone Pocket Spring Support System",
        "Edge Support": "High Density Foam Perimeter Edge Support System",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "Yes",
        "Risk-Free Trial": "100 Nights",
        "Warranty": "10 Years"
    }
}

const laxuraClassic = {
    title: "Luxara Classic Mattress",
    content: {
        "Queen Price": "$1,890",
        "Mattress Type": "Premium Hybrid Innerspring",
        "Mattress Height": "31cm",
        "Number of Layers": "9",
        "Quilted Pillow Top": "7cm",
        "Top Cover": "100% Bamboo Natural Fabric",
        "Wool Layer": "Yes",
        "Side Handles": "Yes",
        "Compressed in a Box": "No",
        "Queen Spring Count": "740",
        "Spring Layers": "Single Layer of Springs",
        "Micro-Spring Layer": "No",
        "Spring Foundation Layer": "Individually Pocketed Springs",
        "Triple tempered Steel Springs": "Yes",
        "GECA Certification": "Yes",
        "Gel-Infused Memory Foam Layer": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "Yes",
        "Australian Made Dunlop Foam Layers": "Yes",
        "Antimicrobial Treatment": "Ultra-Fresh™ Antimicrobial Treatment",
        "Multi-Zone Body Support": "5-Zone Pocket Spring Support System",
        "Edge Support": "High Density Foam Perimeter Edge Support System ",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "Yes",
        "Risk-Free Trial": "100 Nights",
        "Warranty": "10 Years"
    }
}

const sealyCrown = {
    title: "Sealy Posturepedic Crown Jewel Mattress",
    content: {
        "Queen Price": "RRP: Starting from $9,399",
        "Mattress Type": "Luxury Hybrid Innerspring",
        "Mattress Height": "32cm - 38cm",
        "Number of Layers": "9",
        "Quilted Pillow Top": "Only on Select Models",
        "Top Cover": "Damask Fabric",
        "Wool Layer": "Yes",
        "Side Handles": "Yes",
        "Compressed in a Box": "No",
        "Queen Spring Count": "660 + Micro Coils",
        "Spring Layers": "Dual Layer of Springs",
        "Micro-Spring Layer": "Micro Springs",
        "Spring Foundation Layer": "ReST® II Coils",
        "Triple tempered Steel Springs": "No",
        "GECA Certification": "No",
        "Gel-Infused Memory Foam Layer": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No",
        "Antimicrobial Treatment": "HealthShield® Antimicrobial Treatment",
        "Multi-Zone Body Support": "ReST® II Coil 3 Stage Support",
        "Edge Support": "UniCased® XT Edge Support System",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "Yes",
        "Risk-Free Trial": "No",
        "Warranty": "10 Years"
    }
}

const sealyExquisite = {
    title: "Sealy Posturepedic Exquisite Mattress",
    content: {
        "Queen Price": "RRP: Starting from $6,199",
        "Mattress Type": "Premium Hybrid Innerspring",
        "Mattress Height": "32cm - 38cm",
        "Number of Layers": "9",
        "Quilted Pillow Top": "Only on Select Models",
        "Top Cover": "Tencel Fabric",
        "Wool Layer": "Yes",
        "Side Handles": "Yes",
        "Compressed in a Box": "No",
        "Queen Spring Count": "660",
        "Spring Layers": "Single Layer of Springs",
        "Micro-Spring Layer": "No",
        "Spring Foundation Layer": "ReST® II Coils",
        "Triple tempered Steel Springs": "No",
        "GECA Certification": "No",
        "Gel-Infused Memory Foam Layer": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No",
        "Antimicrobial Treatment": "HealthShield® Antimicrobial Treatment",
        "Multi-Zone Body Support": "ReST II Coil 3 Stage Support",
        "Edge Support": "UniCased® XT Edge Support System",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "Yes",
        "Risk-Free Trial": "No",
        "Warranty": "10 Years"
    }
}

const sleepingDuck = {
    title: "Sleeping Duck SD Mach II Mattress",
    content: {
        "Queen Price": "RRP: $1,649",
        "Mattress Type": "Hybrid Innerspring",
        "Mattress Height": "31cm",
        "Number of Layers": "4",
        "Quilted Pillow Top": "No",
        "Top Cover": "30% Bamboo, 70% Polyester",
        "Wool Layer": "No",
        "Side Handles": "Yes",
        "Compressed in a Box": "Yes",
        "Queen Spring Count": "768",
        "Spring Layers": "Single Layer of Springs",
        "Micro-Spring Layer": "No",
        "Spring Foundation Layer": "Pocket Springs",
        "Triple tempered Steel Springs": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Twice Tempered)",
        "GECA Certification": "Yes",
        "Gel-Infused Memory Foam Layer": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No",
        "Antimicrobial Treatment": "No",
        "Multi-Zone Body Support": "Motherboard Multi-Zone Spring System",
        "Edge Support": "Reinforced Edges <br> (No Foam Edge Support)",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "Risk-Free Trial": "100 Nights",
        "Warranty": "10 Years"
    }
}

const koalaSoul = {
    title: "Koala Soul Mate Mattress",
    content: {
        "Queen Price": "RRP: $2,390",
        "Mattress Type": "Foam",
        "Mattress Height": "31cm",
        "Number of Layers": "2",
        "Quilted Pillow Top": "No",
        "Top Cover": "69% Polyester, 28% Viscose",
        "Wool Layer": "No",
        "Side Handles": "No",
        "Compressed in a Box": "Yes",
        "Queen Spring Count": "No",
        "Spring Layers": "No",
        "Micro-Spring Layer": "No",
        "Spring Foundation Layer": "No",
        "Triple tempered Steel Springs": "No",
        "GECA Certification": "No",
        "Gel-Infused Memory Foam Layer": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No",
        "Antimicrobial Treatment": "<img src='//luxara.com.au/cdn/shop/t/22/assets/tik.png?v=174395367860488470121758637412' class='tik' style='height: 24px'/> <br> (Treatment not Specified)",
        "Multi-Zone Body Support": "7-Support Zones",
        "Edge Support": "Edge Support",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "No",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "Risk-Free Trial": "120 nights",
        "Warranty": "10 years"
    }
}

const koalaCalm = {
    title: "Koala Calm As Mattress",
    content: {
        "Queen Price": "RRP: $1,650",
        "Mattress Type": "Foam",
        "Mattress Height": "28cm",
        "Number of Layers": "2",
        "Quilted Pillow Top": "No",
        "Top Cover": "35% Cotton, 65% Polyester",
        "Wool Layer": "No",
        "Side Handles": "No",
        "Compressed in a Box": "Yes",
        "Queen Spring Count": "No",
        "Spring Layers": "No",
        "Micro-Spring Layer": "No",
        "Spring Foundation Layer": "No",
        "Triple tempered Steel Springs": "No",
        "GECA Certification": "Yes",
        "Gel-Infused Memory Foam Layer": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No",
        "Antimicrobial Treatment": "<img src='//luxara.com.au/cdn/shop/t/22/assets/tik.png?v=174395367860488470121758637412' class='tik' style='height: 24px'/> <br> (Treatment not Specified)",
        "Multi-Zone Body Support": "7-Support Zones",
        "Edge Support": "Edge Support",
        "No Partner Disturbance": "Yes",
        "Multiple Comfort Options": "Yes",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "Risk-Free Trial": "120 nights",
        "Warranty": "10 years"
    }
}

const mattresses = {
    laxuraPlatinum,
    laxuraClassic,
    sealyCrown,
    sealyExquisite,
    sleepingDuck,
    koalaSoul,
    koalaCalm
}